import { useMemo } from "react";

import { useCampaignHasSends } from "src/cep/campaigns/campaign-detail/use-campaign-has-sends";
import type { JourneyState } from "src/pages/journeys/types";

// Journeys that have run: live, draining, or turned off.
const JOURNEY_STATES_WITH_SEND_TABS: ReadonlySet<JourneyState> = new Set([
  "active",
  "paused",
  "draining",
  "off",
]);

/** A journey's message gets the campaign page's Reporting and Recipients tabs once it has sent. */
export function canShowMessageSendTabs({
  journeyState,
  hasSends,
}: {
  journeyState: JourneyState | null;
  hasSends: boolean;
}): boolean {
  return (
    hasSends &&
    journeyState != null &&
    JOURNEY_STATES_WITH_SEND_TABS.has(journeyState)
  );
}

export function useMessageSendTabs({
  messageId,
  journeyState,
}: {
  messageId: string;
  journeyState: JourneyState | null;
}): { showSendTabs: boolean; isLoading: boolean } {
  // Only a journey's message can show the tabs, so no other message pays for the count.
  const messages = useMemo(
    () => (journeyState != null && messageId ? [{ id: messageId }] : []),
    [journeyState, messageId],
  );
  const { hasSends, isLoading } = useCampaignHasSends(messages);
  return {
    showSendTabs: canShowMessageSendTabs({ journeyState, hasSends }),
    isLoading,
  };
}
